import { Modal } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import Constants from "../../utils/constants";
import "./styles.scss";

const { LANGUAGES } = Constants;

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "80%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const DescriptionModal = (props) => {
  const { open, handleClose, lang, court, extraInstruction, themeColour } = props;
  const [modalStyle] = useState(getModalStyle);
  const classes = useStyles();

  return (
    <Modal open={open} onClose={handleClose}>
      <div style={modalStyle} className={classes.paper}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3>{LANGUAGES.tips[lang]}</h3>
          <span className="close-btn" onClick={handleClose}>
            x
          </span>
        </div>
        <div>
          {court === "rmb"
            ? LANGUAGES.descriptionRealTimeEtaRmb[lang]
            : LANGUAGES.descriptionRealTimeEta[lang]}
          <div>
            <span className="real-time-eta-num" style={{ color: themeColour }}>3</span>
            <span className="min-text">{LANGUAGES.minute[lang]}</span>
          </div>
        </div>
        <div>
          {court === "rmb"
            ? LANGUAGES.descriptionScheduleEtaRmb[lang]
            : LANGUAGES.descriptionScheduleEta[lang]}
          <div>
            <span className="real-time-eta-num schedule">3</span>
            <span className="min-text">{LANGUAGES.minute[lang]}</span>
          </div>
        </div>
        <p className="line-wrapper">
          <span className="line good"></span>
          {LANGUAGES.descriptionGoodTraffic[lang]}
        </p>
        <p className="line-wrapper">
          <span className="line average"></span>
          {LANGUAGES.descriptionAverageTraffic[lang]}
        </p>
        <p className="line-wrapper">
          <span className="line slow"></span>
          {LANGUAGES.descriptionSlowTraffic[lang]}
        </p>
        <p className="line-wrapper">
          <span className="line deadslow"></span>
          {LANGUAGES.descriptionDeadSlowTraffic[lang]}
        </p>
        {extraInstruction && (
          <p className="line-wrapper">{extraInstruction[lang]}</p>
        )}
      </div>
    </Modal>
  );
};

export default DescriptionModal;
